import styled from 'styled-components';

export const DropdownContainer = styled.div`
  position: fixed;
  top: 26px;
  right: 20px;
  display: inline-block;
  z-index: 1000;
`;

export const DropdownButton = styled.button`
  display: flex;
  align-items: center;
  gap: 8px;
  background-color: white;
  border: none;
  border-radius: 4px;
  padding: 10px 16px;
  font-weight: 500;
  color: #333;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
  cursor: pointer;

  position: fixed;
  bottom: 40px;
  right: 10px;
  svg {
    color: #60a5fa;
  }

  &:hover {
    background-color: #f9f9f9;
  }

  &:focus {
    outline: 2px solid #649dfb;
    border-radius: 12px;
  }
`;

export const DropdownContent = styled.div`
  position: fixed;
  bottom: 30px;
  right: 9px;
  background-color: #ffffff;
  max-width: 200px;
  padding: 8px 0;
  z-index: 1000;
  margin-top: 8px;
  opacity: ${(props) => (props.isOpen ? 1 : 0)};
  transform: ${(props) => (props.isOpen ? 'translateY(0)' : 'translateY(-10px)')};
  visibility: ${(props) => (props.isOpen ? 'visible' : 'hidden')};
  transition: all 0.3s ease-in-out;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  overflow: auto;
  max-height: 600px;
`;

export const CheckboxLabel = styled.label`
  display: flex;
  align-items: center;
  font-size: 14px;
  padding: 8px 16px;
  transition: background-color 0.2s;
  cursor: ${(props) => (props.disabled ? 'not-allowed' : 'pointer')};
  opacity: ${(props) => (props.disabled ? 0.6 : 1)};
  &:hover {
    background-color: ${(props) => (props.disabled ? 'white' : '#f5f5f5')};
  }
`;

export const Checkbox = styled.input`
  margin-right: 12px;
  cursor: ${(props) => (props.disabled ? 'not-allowed' : 'pointer')};
  opacity: ${(props) => (props.disabled ? 0.6 : 1)};
`;

export const DropdownTitle = styled.div`
  padding: 8px 16px;
  border-bottom: 1px solid #eaeaea;
  font-weight: 600;
  color: #333;
  margin-bottom: 4px;
  cursor: ${(props) => (props.disabled ? 'not-allowed' : 'pointer')};
  opacity: ${(props) => (props.disabled ? 0.6 : 1)};
`;
